/**
 * Error Codes Constants
 * 
 * This file contains   // Resource Not Found
  CLAIM_NOT_FOUND,
  DOCUMENT_NOT_FOUND,
  VERIFICATION_NOT_FOUND, possible error codes used throughout the frontend application.
 * These constants should be used instead of hard-coded error strings to ensure consistency
 * and make refactoring easier. Values must match exactly with backend error codes.
 */

// Authentication and Authorization Errors
export const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';
export const ACCESS_DENIED = 'ACCESS_DENIED';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
export const INSUFFICIENT_PERMISSIONS = 'INSUFFICIENT_PERMISSIONS';
export const USER_NOT_FOUND = 'USER_NOT_FOUND';
export const UNAUTHORIZED = 'UNAUTHORIZED';

// Resource Not Found Errors
export const CLAIM_NOT_FOUND = 'CLAIM_NOT_FOUND';
export const DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND';
export const VERIFICATION_NOT_FOUND = 'VERIFICATION_NOT_FOUND';

// Validation Errors
export const VALIDATION_ERROR = 'VALIDATION_ERROR';
export const MISSING_REQUIRED_FIELD = 'MISSING_REQUIRED_FIELD';
export const INVALID_INPUT_FORMAT = 'INVALID_INPUT_FORMAT';
export const INVALID_FILE_TYPE = 'INVALID_FILE_TYPE';
export const FILE_TOO_LARGE = 'FILE_TOO_LARGE';
export const INVALID_GHANA_CARD_FORMAT = 'INVALID_GHANA_CARD_FORMAT';

// Business Logic Errors
export const CLAIM_ALREADY_SUBMITTED = 'CLAIM_ALREADY_SUBMITTED';
export const CLAIM_CANNOT_BE_MODIFIED = 'CLAIM_CANNOT_BE_MODIFIED';
export const DOCUMENT_ALREADY_EXISTS = 'DOCUMENT_ALREADY_EXISTS';
export const VERIFICATION_ALREADY_EXISTS = 'VERIFICATION_ALREADY_EXISTS';
export const VERIFICATION_ALREADY_LINKED = 'VERIFICATION_ALREADY_LINKED';

// External Service Errors
export const NIA_SERVICE_UNAVAILABLE = 'NIA_SERVICE_UNAVAILABLE';
export const NIA_VERIFICATION_FAILED = 'NIA_VERIFICATION_FAILED';
export const EXTERNAL_SERVICE_ERROR = 'EXTERNAL_SERVICE_ERROR';
export const SERVICE_TIMEOUT = 'SERVICE_TIMEOUT';

// System Errors
export const DATABASE_ERROR = 'DATABASE_ERROR';
export const INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR';
export const STORAGE_SERVICE_ERROR = 'STORAGE_SERVICE_ERROR';
export const NETWORK_ERROR = 'NETWORK_ERROR';

// Helper object for easy access and iteration
export const ERROR_CODES = {
  // Authentication and Authorization
  INVALID_CREDENTIALS,
  ACCESS_DENIED,
  TOKEN_EXPIRED,
  INSUFFICIENT_PERMISSIONS,
  USER_NOT_FOUND,
  UNAUTHORIZED,
  
  // Resource Not Found
  CLAIM_NOT_FOUND,
  DOCUMENT_NOT_FOUND,
  VERIFICATION_NOT_FOUND,
  
  // Validation
  VALIDATION_ERROR,
  MISSING_REQUIRED_FIELD,
  INVALID_INPUT_FORMAT,
  INVALID_FILE_TYPE,
  FILE_TOO_LARGE,
  INVALID_GHANA_CARD_FORMAT,
  
  // Business Logic
  CLAIM_ALREADY_SUBMITTED,
  CLAIM_CANNOT_BE_MODIFIED,
  DOCUMENT_ALREADY_EXISTS,
  VERIFICATION_ALREADY_EXISTS,
  VERIFICATION_ALREADY_LINKED,
  
  // External Services
  NIA_SERVICE_UNAVAILABLE,
  NIA_VERIFICATION_FAILED,
  EXTERNAL_SERVICE_ERROR,
  SERVICE_TIMEOUT,
  
  // System
  DATABASE_ERROR,
  INTERNAL_SERVER_ERROR,
  STORAGE_SERVICE_ERROR,
  NETWORK_ERROR
};

// User-friendly error messages
export const ERROR_MESSAGES = {
  [INVALID_CREDENTIALS]: 'Invalid username or password',
  [ACCESS_DENIED]: 'Access denied',
  [TOKEN_EXPIRED]: 'Your session has expired. Please log in again',
  [INSUFFICIENT_PERMISSIONS]: 'You do not have permission to perform this action',
  [USER_NOT_FOUND]: 'User not found',
  [UNAUTHORIZED]: 'You are not authorized to access this resource',
  
  [CLAIM_NOT_FOUND]: 'Claim not found',
  [DOCUMENT_NOT_FOUND]: 'Document not found',
  [VERIFICATION_NOT_FOUND]: 'Verification record not found',
  
  [VALIDATION_ERROR]: 'Please check your input and try again',
  [MISSING_REQUIRED_FIELD]: 'Please fill in all required fields',
  [INVALID_INPUT_FORMAT]: 'Invalid input format',
  [INVALID_FILE_TYPE]: 'Invalid file type. Please upload a supported file format',
  [FILE_TOO_LARGE]: 'File is too large. Please upload a smaller file',
  [INVALID_GHANA_CARD_FORMAT]: 'Please enter a valid Ghana Card number',
  
  [CLAIM_ALREADY_SUBMITTED]: 'This claim has already been submitted',
  [CLAIM_CANNOT_BE_MODIFIED]: 'This claim cannot be modified in its current state',
  [DOCUMENT_ALREADY_EXISTS]: 'This document already exists',
  [VERIFICATION_ALREADY_EXISTS]: 'Verification already exists for this Ghana Card',
  [VERIFICATION_ALREADY_LINKED]: 'This verification is already linked to another claim',
  
  [NIA_SERVICE_UNAVAILABLE]: 'Verification service is temporarily unavailable',
  [NIA_VERIFICATION_FAILED]: 'Ghana Card verification failed. Please check your details',
  [EXTERNAL_SERVICE_ERROR]: 'External service error. Please try again later',
  [SERVICE_TIMEOUT]: 'Service request timed out. Please try again',
  
  [DATABASE_ERROR]: 'A database error occurred. Please try again later',
  [INTERNAL_SERVER_ERROR]: 'An internal server error occurred. Please contact support',
  [STORAGE_SERVICE_ERROR]: 'File storage service is unavailable',
  [NETWORK_ERROR]: 'Network error. Please check your internet connection'
};
